// @flow
import { default as SwitcherDouble } from './switcher';
import { default as SwitcherDoubleTemplate } from './templates/index.html';

export const COMPONENTS_SWITCHER_DOUBLE_NAME = 'switcher-double';

export const COMPONENTS_SWITCHER_DOUBLE_ENTITIES = [
	{
		name: COMPONENTS_SWITCHER_DOUBLE_NAME,
		entity: SwitcherDouble,
		template: SwitcherDoubleTemplate,
	},
];
